/** 组织成员。role 取值 'admin' | 'member'。 */
export class OrganizationMember {
  userId: string = '';
  role: string = '';
  name: string = '';
  email: string = '';
  remark: string = '';
  update: Date | null = null;
}

/** 创建者（组织 / 空间共用的人「快照」）。 */
export class Person {
  id: string = '';
  name: string = '';
  timestamp: Date | null = null;
}

/** 组织。`id`（本地）对应线上的 `code`（见 UserOrganizationCodec）。 */
export class UserOrganization {
  id: string = '';
  name: string = '';
  creator: Person = new Person();
  members: OrganizationMember[] = [];
  personal: boolean = false;

  /** 当前账号在组织里的角色，纯本地推算（不进编解码）。 */
  _role: string = 'member';
}